// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"f9c18c15","563":"d1402b12","787":"0e843cad"}[chunkId] + ".chunk.js";
};